export default  {
    bindings: {
        extra: '='
    },
    controller: 'extrasFormController',
    template: require('../views/extras.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/extras.form.component.js